import axios from 'axios';
import { getApiBaseUrl } from '../lib/api-base-url';

const API_URL = getApiBaseUrl();

type DomainUnit = 'g' | 'h' | null;

export interface PayslipBalanceItem {
  id: number;
  tenantId: number;
  userId: number;
  documentId: number | null;
  payslipMonth: number;
  payslipYear: number;
  hoursPerDay: number | string;
  ferieResiduo: number | string | null;
  ferieProiezione: number | string | null;
  permessiResiduo: number | string | null;
  permessiProiezione: number | string | null;
  rolResiduo: number | string | null;
  rolProiezione: number | string | null;
  exFestResiduo: number | string | null;
  exFestProiezione: number | string | null;
  ferieUnit: DomainUnit;
  permessiUnit: DomainUnit;
  rolUnit: DomainUnit;
  exFestUnit: DomainUnit;
  totalDaysResidual: number | string | null;
  totalDaysProjection: number | string | null;
  source: string;
  createdByUserId: number;
  createdAt: string;
  updatedAt: string;
}

interface DomainInput {
  precedente?: number | null;
  maturato?: number | null;
  goduto?: number | null;
  residuo?: number | null;
  proiezione?: number | null;
}

export interface UpsertPayslipBalancePayload {
  userId: number;
  documentId?: number | null;
  payslipMonth: number;
  payslipYear: number;
  hoursPerDay?: number;
  source?: string;
  ferie?: DomainInput;
  permessi?: DomainInput;
  rol?: DomainInput;
  exFest?: DomainInput;
  units?: {
    ferie?: DomainUnit;
    permessi?: DomainUnit;
    rol?: DomainUnit;
    exFest?: DomainUnit;
  };
  computed?: {
    totalDaysResidual?: number | null;
    totalDaysProjection?: number | null;
  };
}

export const payslipBalanceService = {
  upsert: async (payload: UpsertPayslipBalancePayload): Promise<PayslipBalanceItem> => {
    const response = await axios.post(`${API_URL}/payslip-balances`, payload);
    return response.data;
  },

  getMy: async (): Promise<PayslipBalanceItem[]> => {
    const response = await axios.get(`${API_URL}/payslip-balances/my`);
    return response.data;
  },

  getMyPeriod: async (year: number, month: number): Promise<PayslipBalanceItem> => {
    const response = await axios.get(`${API_URL}/payslip-balances/my/${year}/${month}`);
    return response.data;
  },
};
